import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {ItemSetting} from "../../models/itemSetting.model";
import {FulfillmentPackageSplitType} from "../../../fulfillment/types/fulfillment-package-split.type";

export class PricePlanBundlePackageItemsTableRow implements IController {
  packageItem: ItemSetting;
  isDefault: boolean;
  isEditMode: boolean;
  onEdit: Function;
  onDelete: Function;
  onSave: Function;
  onCancel: Function;
  onChangeDefault: Function;

  public siteLabels: any;
  public weightConfig: any;
  public dimensionsConfig: any;
  public siteCurrencySymbol: any;
  public isDesktop: boolean;
  public packageItemCopy: ItemSetting;
  public fulfillmentPackageSplitType: typeof FulfillmentPackageSplitType = FulfillmentPackageSplitType;
  public packageConfigName: string;
  public packageConfigId: string;


  /* @ngInject */
  constructor(private splitService: SplitService, private $mdMedia) {
    this.siteLabels = this.splitService.getSiteLabels();
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();
    this.siteCurrencySymbol = this.splitService.getCurrencySymbol();
    this.isDesktop = this.$mdMedia('gt-md');
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
    if (changes.isEditMode && !changes.isEditMode.isFirstChange()) {
      this.packageItemCopy = this.isEditMode ? angular.copy(this.packageItem) : undefined;
      if (!!this.packageItemCopy && !this.packageItemCopy.dimensions) {
        _.set(this.packageItemCopy, 'dimensions', {});
      }
    }
  };

  onChange(packageItem) {
    this.packageItemCopy = packageItem;
  }

  onPackageConfigChange(id) {
    // this.packageItemCopy = packageItem;
    if (id) {
      this.packageItemCopy.packageConfigurationId = id;
    } else {
      delete this.packageItemCopy.packageConfigurationId
    }
  }

  onLabelChanges(labels) {
    this.packageItemCopy.labels = labels;
  }

  onToggleDefault() {
    const packageItem = angular.copy(this.packageItem)
    packageItem.defaultSize = true;

    this.onChangeDefault({packageItem: packageItem})
  }

  // onToggleDefault(isDefault) {
  //   this.packageItem.defaultSize = isDefault ? isDefault : true;
  //
  //   if (!!isDefault) {
  //     this.onChangeDefault({packageItem: this.packageItem})
  //   }
  //
  // }

  save(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        this.onSave({packageItem: this.packageItemCopy})
      }

    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundlePackageItemsTableRow', {
    bindings: {
      packageItem: '<',
      isDefault: '<?',
      isEditMode: '<?',
      onEdit: '&',
      onSave: '&',
      onCancel: '&',
      onChangeDefault: '&'
    },
    template: require('./price-plan-bundle-package-items-table-row.html').default,
    controller: PricePlanBundlePackageItemsTableRow
  });
